import { rootApi } from '../root-api'
import {
  IRefillConditions,
  ITelegramCountries,
  ITelegramSubject,
  ITelegramSubjectInfo,
  ITikTokConditions,
} from './types'

export const financialTermsApi = rootApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    getTelegramSubjectInfo: build.query<ITelegramSubjectInfo, { subject: string | null; country?: string | null }>({
      query: ({ subject, country }) => {
        const params: Record<string, string | null> = {
          subject,
        }

        if (country) {
          params.country = country
        }

        return {
          url: 'telegram_accounts/telegram-financial-conditions/',
          params,
        }
      },
    }),
    getTelegramSubjects: build.query<ITelegramSubject[], void>({
      query: () => ({
        url: 'telegram_accounts/telegram-financial-conditions/available-subjects/',
      }),
    }),
    getAllSubjects: build.query<ITelegramSubject[], void>({
      query: () => ({
        url: 'telegram_accounts/subjects/',
      }),
    }),
    getTelegramCountries: build.query<ITelegramCountries[], void>({
      query: () => ({
        url: 'telegram_accounts/telegram-financial-conditions/available-countries/',
      }),
    }),
    getTikTokConditions: build.query<ITikTokConditions, void>({
      query: () => ({
        url: 'tiktok/tiktok-financial-conditions/',
      }),
    }),
    getRefillConditions: build.query<IRefillConditions, void>({
      query: () => ({
        url: 'profile/refill-conditions/',
      }),
    }),
  }),
})

export const {
  useGetTelegramSubjectInfoQuery,
  useGetTikTokConditionsQuery,
  useGetRefillConditionsQuery,
  useGetTelegramCountriesQuery,
  useGetTelegramSubjectsQuery,
  useGetAllSubjectsQuery,
} = financialTermsApi
